import { createSlice } from "@reduxjs/toolkit";
import { RESET } from "../types";

const initialState = {
  center: { lat: 0, lng: 0 },
  radiusMarkers: [],
  // Max order pins the dispatch map may draw at once (-1 = unlimited).
  // Sourced from the plan's `max_map_orders` via /subscriptions/usage/.
  orderLimit: -1,
};

const mapSlice = createSlice({
  name: "map",
  initialState,
  reducers: {
    setCenter: (state, action) => {
      console.log("handleChangeMapCenter", action.payload);
      state.center = action.payload;
    },
    setRadiusMarkers: (state, action) => {
      state.radiusMarkers = action.payload;
    },
    setMapOrderLimit: (state, action) => {
      const limit = action.payload;
      // Fail open: anything not a positive number means "no cap".
      state.orderLimit = Number.isFinite(limit) && limit > 0 ? limit : -1;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(RESET, () => initialState);
  },
});

export const { setCenter, setRadiusMarkers, setMapOrderLimit } =
  mapSlice.actions;
export default mapSlice.reducer;
